export { default } from './PropertyAndLoan';
